import PropTypes from 'prop-types';

const Iframe = ({ id = 'iframe', url, name = '', width = '100vw', height = '100%', className }) => (
  <iframe
    id={id}
    title={name}
    src={url}
    style={{
      margin: 0,
      border: 0,
      marginBottom: '-8px',
      width: width === '100vw' ? '100%' : width,
      height: height,
    }}
    className={className}
  />
);

Iframe.propTypes = {
  id: PropTypes.string,
  url: PropTypes.string.isRequired,
  name: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string,
};

export default Iframe;